"use client";

import React from "react";
import { Building2, Users, HeartHandshake, Globe } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Daily Assistance",
  description: "Providing respectful support with mobility, grooming, and all aspects of everyday life within our warm residential home.",
  icon: Building2
}, {
  title: "Medication Management",
  description: "Professional oversight and careful administration to ensure the health and safety of every resident with precision care.",
  icon: Users
}, {
  title: "Social Engagement",
  description: "Creating meaningful connections through daily activities that promote mental wellness and foster a vibrant community joy.",
  icon: HeartHandshake
}, {
  title: "Personalized Care",
  description: "Individualized wellness plans designed to honor the unique life story, preferences, and health goals of each senior.",
  icon: Globe
}];
export default function AlliloopBuildsBridgesAcrossTheCareEconomy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="76982" id="compassionate-support" className="bg-white text-[#1a1a1a] py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2 className="text-[#091b3a] text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.4] md:leading-[1.5] tracking-tight">
            Compassionate Support at Moonrise Residential Care
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full bg-white border border-slate-100 p-8 flex flex-col gap-0 transition-all duration-300 ease-out hover:-translate-y-2 hover:border-[#ffbd00]/30 hover:shadow-[0_15px_30px_-10px_rgba(9,27,58,0.15)] group">
                  <div className="mb-8">
                    <Icon className="size-8 text-[#ffbd00] transition-transform duration-300 group-hover:scale-110 group-hover:drop-shadow-[0_0_8px_rgba(255,189,0,0.4)]" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-xl font-semibold text-[#091b3a] mb-4">
                    {feature.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}